import React from "react";

export const GameModeContext = React.createContext();
